import React from 'react';
import { Modal, Button, FormGroup, FormControl, HelpBlock, ControlLabel, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { linkPolicySchema } from 'insured-ui-state-mgmt/dist/util/yup_validations/registration/schema';
import { extraOperations } from 'insured-ui-state-mgmt/dist/ducks/extra';
import { accountOperations } from 'insured-ui-state-mgmt/dist/ducks/account';
import Loading from '../registrationScreens/Loading';

export function getErrorForItem(errors, itemName) {
  if (!errors.inner) {
    return [];
  }

  let items = errors.inner.filter(item => {
    if (item.path === itemName) {
      return true;
    }
    return false;
  });
  return items;
}

class LinkPolicyScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
      isLoading: false,
      data: {
        policyNumber: '',
      },
      errors: [],
    };

    props.hideSecurityPortlet();
  }

  componentDidUpdate(prevProps) {
    
    if (!Object.is(this.props.policyInfo, prevProps.policyInfo)) {
      //close the dialog and show the next screen

      console.log(this.props.policyInfo);

      if (this.props.policyInfo.policyNumber && this.props.policyInfo.policyType) {
        this.handleClose();
        this.showNextScreen();
      }
    }
  }

  handleClose = () => {
    console.log("in handle close")
    this.setState(
      {
        show: false,
        data: {
          policyNumber: '',
        },
        errors: '',
        isLoading: false,
      },

      () => {
        this.props.hideSecurityPortlet();
        this.props.clearAccount();
      }
    );
  };

  showNextScreen = () => {
    console.log("in showNext SCreen")
    this.props.transition.router.stateService.go('registrationScreen2', {});
  };

  handleSubmit = event => {
    console.log("in handle submit");
    event.preventDefault();
    const { data } = this.state;

    linkPolicySchema
      .validate({ ...data }, { abortEarly: false })
      .then(response => {
        console.log('success');

        this.setState({ errors: [] }, () => this.props.getPolicTypeForWithPolicyNumber(this.state.data.policyNumber));
      })
      .catch(issues => {
        console.log('error');
        this.props.clearAccount();
        this.setState({
          errors: issues,
        });
      });
  };

  handleChange = event => {
    console.log("in handle change")
    this.setState({
      data: {
        ...this.state.data,
        policyNumber: event.target.value.trim(),
      },
    });
  };

  getValidationState() {
    return null;
  }

  render() {
    const { isLoading, data, errors } = this.state;
    const { loading } = this.props;

    if (!this.props.extra.show) {
      return null;
    }

    return (
      <Modal
        show={this.props.extra.show}
        onHide={this.handleClose}
        backdrop="static"
        dialogClassName="modal-md modal_400 relative_position"
      >
        <Modal.Header closeButton={!Boolean(loading)}>
          <Modal.Title bsClass="modal-title font_weight_bold">Create Account</Modal.Title>
        </Modal.Header>

        {Boolean(loading) && <Loading show={Boolean(loading)} />}

        {!Boolean(loading) && (
          <Modal.Body style={{ margin: '20px 25px' }} bsClass="modal-body modal_body_450">
            <p style={{ textAlign: 'center' }}>Input your policy number to get started.</p>

            <form onSubmit={this.handleSubmit} style={{ marginTop: 35 }}>
              <FormGroup controlId="linkPolicyForm" validationState={this.getValidationState()}>
                <ControlLabel>Policy Number</ControlLabel>
                <FormControl
                  type="text"
                  value={data.policyNumber}
                  onClick={this.handleClick}
                  onChange={this.handleChange}
                  autoComplete='off'
                />
                {getErrorForItem(errors, 'policyNumber').length > 0 && (
                  <HelpBlock bsClass="text-danger">{getErrorForItem(errors, 'policyNumber')[0].message}</HelpBlock>
                )}
              </FormGroup>

              <Button
                type="submit"
                bsStyle="primary"
                bsSize="large"
                // bsClass="btn font_weight_bold"
                block
                disabled={isLoading}
                style={{ marginTop: 30, fontWeight: 'bold' }}
              >
                Get Started
              </Button>
            </form>
            {this.props.response &&
              this.props.response.error && (
                <Alert bsStyle="danger" style={{ marginTop: 20 }}>
                  <strong>Error</strong> {this.props.response.error.message}
                </Alert>
              )}
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account.registrationDetails,
  response: state.account.response,
  policyInfo: state.account.policyInfo,
  extra: state.extra,
  loading: state.loading,
});

const mapDispatchToProps = {
  showSecurityPortlet: extraOperations.showSecurityPortlet,
  hideSecurityPortlet: extraOperations.hideSecurityPortlet,
  getPolicTypeForWithPolicyNumber: accountOperations.getPolicTypeForWithPolicyNumber,
  clearAccount: accountOperations.clearAccount,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LinkPolicyScreen);
